import React from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'
import PrizeBadge from '../../../../../components/ScopedBlock/PrizeBadge.svg?url'

export const DelegatedEmailCardBadge: React.FC = () => {
  const { hasQuota } = useZocksQuota()

  if (hasQuota('integration.delegatedEmailEnabled.value')) {
    return null
  }

  return <img alt='Upgrade' src={PrizeBadge} width={20} height={20} />
}
